import type { Artist } from "./types";

export const artist: Artist = {
  name: "7 Minutes Dead",
  shortBio:
    "7 Minutes Dead makes cool songs. Up next is some UK Garage at Techno BPM via our friends at mau5trap.",
  mediumBio:
    "7 Minutes Dead is a one-man electronic project working out of Dallas, TX, with a discography spanning mau5trap, Monstercat, and self-released material across house, techno, and garage. Influences run from Deadmau5 / Daft Punk / Justice to Fred Again, Dylan Brady, and Skrillex. New single SWEET OUTSIDE lands June 12, 2026 on mau5trap.",
  aboutTeaser:
    "7 MINUTES DEAD (Alex) grew up on Deadmau5, Daft Punk and Justice. These days he's heavily inspired by Fred Again, Dylan Brady and Skrillex (who isn't).",
  longBio:
    "7 Minutes Dead makes sick tunes. What else do you need to know?\n\nHe's a one-man show from the Midwest. He grew up on 128, released many 100s, and now you're seeing 150s!\n\nmau5trap and Monstercat releases.\n\nHe was forged in Deadmau5, Daft Punk and Justice. These days he's heavily inspired by Fred Again, Dylan Brady and Skrillex (who isn't).\n\nHe's worked with Chris James (of the Veldt) and Varien (check out the full Mirai Sekai mix). He ran a duo project named Orbiter (listen to We Do). If you want more Mirai Sekai length, perhaps keep an eye out for MY ONLY ONE!",
  basedIn: "Dallas, TX",
  genres: [
    "house",
    "techno",
    "bass house",
    "UK garage",
    "stutter house",
    "future garage",
  ],
  primaryPhoto: {
    ref: { kind: "public", key: "public/artwork/site/hero/hero-wide-1600.jpg" },
    alt: "7 Minutes Dead — Diamond Cat cover art",
    width: 1600,
    height: 900,
  },
  socials: [
    { platform: "spotify", url: "https://open.spotify.com/artist/6MXp12IK29WvwsSbj5j49p" },
    { platform: "soundcloud", url: "https://soundcloud.com/7minutesdead" },
    { platform: "instagram", url: "https://www.instagram.com/sevenminutesdead/" },
    { platform: "youtube", url: "https://www.youtube.com/user/7minutesdead" },
  ],
  contacts: [
    { role: "self", name: "Alex", email: "alex@7minutes.dev" },
  ],
  totalReleases: 23,
};
